var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappGreenTicks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62634 3.8468C9.87378 3.53886 10.324 3.4893 10.6322 3.73645C10.9403 3.98373 10.9904 4.43403 10.7435 4.74231L4.55798 12.4474C4.43076 12.6059 4.24235 12.7028 4.03943 12.714C3.83648 12.7251 3.63831 12.6496 3.49451 12.506L0.994507 10.006C0.714985 9.72647 0.71405 9.27283 0.99353 8.99329C1.27299 8.71399 1.72672 8.71405 2.00623 8.99329L3.94177 10.9288L9.62634 3.8468ZM13.7123 3.8468C13.9598 3.53864 14.4109 3.48904 14.7191 3.73645C15.0271 3.98379 15.0764 4.43409 14.8295 4.74231L8.64392 12.4474C8.51664 12.6059 8.32834 12.7029 8.12537 12.714C7.92238 12.7251 7.72425 12.6497 7.58044 12.506L6.58044 11.507C6.3011 11.2276 6.3005 10.7738 6.57947 10.4943C6.85887 10.2149 7.3126 10.2142 7.59216 10.4933L8.02771 10.9279L13.7123 3.8468Z",
    fill: "#399D81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappGreenTicks);
export default __webpack_public_path__ + "static/media/whatsapp-green-ticks.81f22932fd08a2ecac4462c4172badc4.svg";
export { ForwardRef as ReactComponent };